import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

interface Options {
    enabled: boolean;
}

export function useTimelineDraftQuery(options: Options) {
    const { project } = useProject();
    return useQuery({
        queryFn: async () => {
            const res = await apiClient.generateDraftProjectTimeline({
                params: {
                    projectId: project.id,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to fetch project timeline draft");
            }
            return res.body.deliverables;
        },
        queryKey: ["project", project.id, "timeline-draft"],
        enabled: options.enabled,
    });
}
